import { useMutation as o } from "@apollo/client";
import a from "../../graphql/client/loginClient.js";
import { deserializeResponse as u } from "../../graphql/deserialize/index.js";
import c from "../../graphql/mutation/bindFingerprint.js";
import { useCallback as p } from "react";
const q = () => {
  const [t, { loading: r }] = o(c, {
    client: a
  });
  return {
    mutate: p(
      async (e) => {
        const { requestId: s, visitorId: i } = e, n = await t({
          variables: {
            fingerprintInput: {
              requestID: s,
              visitorID: i
            }
          }
        });
        return u(n);
      },
      [t]
    ),
    loading: r
  };
};
export {
  q as default
};
//# sourceMappingURL=useBindFingerprint.js.map
